module.exports = __webpack_public_path__ + "img/oporto.9e2ac677.jpg";